import { HelmetProvider } from "react-helmet-async";
import { LayoutProvider } from "../../../context/useLayoutContext";
import PageMetaData from "../../../components/PageMetaData";
import TopNavBar from "../../../components/TopNavBar";
import Services from "../components/Services";
import Footer from "../components/Footer";
import Calculator from "../components/Calculator";
import { useState } from "react";

const ServicesPage = () => {
  const [showCalculator, setShowCalculator] = useState(false);

  const handleShowCalculator = () => {
    setShowCalculator(!showCalculator);
  };
  return (
    <>
      <HelmetProvider>
        <LayoutProvider>
          <PageMetaData title="Geo Express | Services" />
          <TopNavBar
            position="fixed"
            menuItems={[
              ["მთავარი", "home", "/"],
              ["სერვისები", "services", "/services", true],
              ["სიახლეები", "news", "/news"],
              ["კონტაქტი", "contact", "/contact"],
              ["ხშირად დასმული კითხვები", "faqs", "/faq"],
              ["განსაბაჟებელი გზავნილები", "shipment", "/shipment"],
            ]}
            onCalculatorClick={handleShowCalculator}
          />
          <Calculator
            show={showCalculator}
            onClose={() => setShowCalculator(false)}
          />
          <Services />
          <Footer />
        </LayoutProvider>
      </HelmetProvider>
      {/* //განსაბაჟებელი გზავნილები  CustomableShipment*/}
    </>
  );
};

export default ServicesPage;
